import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import ForgotPasswordPage from './pages/Forgot';
import ResetPage from './pages/Reset';
import AdminDashboard from './pages/admin';
import AdminToolsPage from './pages/admin-tools';
import MyAccountPage from './pages/my-account';
import AdminUsersPage from './pages/users';
import AddUserPage from './pages/users/add';
import UserDetailPage from './pages/users/[id]';
import CardsPage from './pages/cards';
import AddCardPage from './pages/cards/add';
import CardDetailPage from './pages/cards/[id]';
import FuneralCompaniesPage from './pages/funeral-companies';
import AddFuneralCompanyPage from './pages/funeral-companies/add';
import FuneralCompanyDetailPage from './pages/funeral-companies/[id]';
import DesignersPage from './pages/designers';
import AddDesignerPage from './pages/designers/add';
import DesignerDetailPage from './pages/designers/[id]';
import ObituariesPage from './pages/obituaries';
import ObituaryDetailPage from './pages/obituaries/[id]';
import PublicObituaryViewPage from './pages/obituaries/view/[id]';
import BranchesPage from './pages/branches';
import BranchDetailPage from './pages/branches/[id]';
import CompanyBranchesPage from './pages/funeral-companies/[id]/branches';
import BranchObituariesPage from './pages/funeral-companies/[id]/branches/[id]/obituaries';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot" element={<ForgotPasswordPage />} />
          <Route path="/reset" element={<ResetPage />} />
          <Route path="/obituaries/view/:id" element={<PublicObituaryViewPage />} />
          
          {/* Protected routes */}
          <Route path="/" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin-tools" element={<ProtectedRoute><AdminToolsPage /></ProtectedRoute>} />
          <Route path="/my-account" element={<ProtectedRoute><MyAccountPage /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><AdminUsersPage /></ProtectedRoute>} />
          <Route path="/users/add" element={<ProtectedRoute><AddUserPage /></ProtectedRoute>} />
          <Route path="/users/:id" element={<ProtectedRoute><UserDetailPage /></ProtectedRoute>} />
          <Route path="/cards" element={<ProtectedRoute><CardsPage /></ProtectedRoute>} />
          <Route path="/cards/add" element={<ProtectedRoute><AddCardPage /></ProtectedRoute>} />
          <Route path="/cards/:id" element={<ProtectedRoute><CardDetailPage /></ProtectedRoute>} />
          <Route path="/companies" element={<ProtectedRoute><FuneralCompaniesPage /></ProtectedRoute>} />
          <Route path="/companies/add" element={<ProtectedRoute><AddFuneralCompanyPage /></ProtectedRoute>} />
          <Route path="/companies/:id" element={<ProtectedRoute><FuneralCompanyDetailPage /></ProtectedRoute>} />
          <Route path="/designers" element={<ProtectedRoute><DesignersPage /></ProtectedRoute>} />
          <Route path="/designers/add" element={<ProtectedRoute><AddDesignerPage /></ProtectedRoute>} />
          <Route path="/designers/:id" element={<ProtectedRoute><DesignerDetailPage /></ProtectedRoute>} />
          <Route path="/obituaries" element={<ProtectedRoute><ObituariesPage /></ProtectedRoute>} />
          <Route path="/obituaries/:id" element={<ProtectedRoute><ObituaryDetailPage /></ProtectedRoute>} />
          <Route path="/branches" element={<ProtectedRoute><BranchesPage /></ProtectedRoute>} />
          <Route path="/branches/:id" element={<ProtectedRoute><BranchDetailPage /></ProtectedRoute>} />
          <Route path="/companies/:id/branches" element={<ProtectedRoute><CompanyBranchesPage /></ProtectedRoute>} />
          <Route path="/companies/:companyId/branches/:id" element={<ProtectedRoute><BranchDetailPage /></ProtectedRoute>} />
          <Route path="/companies/:companyId/branches/:branchId/obituaries" element={<ProtectedRoute><BranchObituariesPage /></ProtectedRoute>} />
          <Route path="/companies/:companyId/branches/:branchId/obituaries/:id" element={<ProtectedRoute><ObituaryDetailPage /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" />
      </Router>
    </AuthProvider>
  );
}

export default App;